var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSFinalizado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_151_9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 15,
    height: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0C15.7956 0 16.5587 0.316071 17.1213 0.87868C17.6839 1.44129 18 2.20435 18 3V15C18 15.7956 17.6839 16.5587 17.1213 17.1213C16.5587 17.6839 15.7956 18 15 18H3C2.20435 18 1.44129 17.6839 0.87868 17.1213C0.316071 16.5587 0 15.7956 0 15V3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0H15ZM13.47 4.97L7 11.44L4.53 8.97C4.38783 8.83752 4.19978 8.7654 4.00548 8.76882C3.81118 8.77225 3.62579 8.85097 3.48838 8.98838C3.35097 9.12579 3.27225 9.31118 3.26883 9.50548C3.2654 9.69978 3.33752 9.88782 3.47 10.03L6.47 13.03C6.61063 13.1705 6.80125 13.2493 7 13.2493C7.19875 13.2493 7.38937 13.1705 7.53 13.03L14.53 6.03C14.6625 5.88782 14.7346 5.69978 14.7312 5.50548C14.7277 5.31118 14.649 5.12579 14.5116 4.98838C14.3742 4.85097 14.1888 4.77225 13.9945 4.76883C13.8002 4.7654 13.6122 4.83752 13.47 4.97Z",
    fill: "#65FA74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_151_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSFinalizado);
export default __webpack_public_path__ + "static/media/ico_s_finalizado.84d41c97c7f055f91be49ac0b913bc15.svg";
export { ForwardRef as ReactComponent };